/**
 * The sidebar folded (07 Workshop, Chat in a project · sidebar folded, approved
 * A on 9 Oct): a 56px strip of ghost icons, the sidebar's own rows without
 * their words (open the sidebar, New chat, Search, Creos), a rule, and the open
 * project as one accent folder that goes to its home.
 */
import { FolderOpen, PanelLeftOpen, Search, SquarePen, Zap, type LucideIcon } from "lucide-react";
import type { WorkshopSurface } from "./workshopDesk";
import { useWorkshopDesk } from "./workshopDesk";

type Props = {
  surface: WorkshopSurface;
  /** The open project's name, for its folder's label. */
  projectName: string | null;
  onUnfold: () => void;
};

function StripButton({
  icon: Icon,
  label,
  onPress,
  current = false,
}: {
  icon: LucideIcon;
  label: string;
  onPress: () => void;
  current?: boolean;
}) {
  return (
    <button
      type="button"
      className="ws-fold-btn"
      onClick={onPress}
      aria-label={label}
      title={label}
      aria-current={current ? "page" : undefined}
    >
      <Icon aria-hidden="true" />
    </button>
  );
}

export default function WorkshopFoldedSidebar({ surface, projectName, onUnfold }: Props) {
  const desk = useWorkshopDesk();
  const projectId = desk.activeProjectId;
  return (
    <nav className="ws-fold" aria-label="Workshop">
      <StripButton icon={PanelLeftOpen} label="Show the sidebar" onPress={onUnfold} />
      <StripButton icon={SquarePen} label="New chat" onPress={() => desk.newChat()} />
      <StripButton icon={Search} label="Search" onPress={desk.openSearch} />
      <StripButton icon={Zap} label="Creos" onPress={desk.openCreos} current={surface === "creos"} />
      {projectId ? (
        <>
          <span className="ws-fold-rule" aria-hidden="true" />
          <button
            type="button"
            className="ws-fold-project"
            onClick={() => desk.openProject(projectId)}
            aria-label={projectName ? `${projectName}, the project's home` : "The project's home"}
            title={projectName ?? undefined}
            aria-current={surface === "project" ? "page" : undefined}
          >
            <FolderOpen aria-hidden="true" />
          </button>
        </>
      ) : null}
    </nav>
  );
}
